import styled from 'styled-components';

/** Full-width shell — ≥95% of viewport, capped (Maison/catalog rhythm). */
export const Container = styled.div`
  width: ${({ theme }) => theme.layout.catalogWidth};
  max-width: ${({ theme }) => theme.layout.catalogMaxWidth};
  margin-left: auto;
  margin-right: auto;
  padding-left: ${({ theme }) => theme.layout.containerPadX};
  padding-right: ${({ theme }) => theme.layout.containerPadX};
`;

export const PageFade = styled.div`
  animation: fade-in 0.6s ${({ theme }) => theme.easeLuxe} both;
`;
